import axios from "axios";
import { config } from "../../Utils/helpers";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const getFranchiseManagerList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_LIST_FAIL",
                    payload: data.message || "List failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};


export const AddFranchiseManager = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_ADD_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/add`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_ADD_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_ADD_FAIL",
                    payload: data.message || "Add failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_ADD_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseManagerProjectList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/projectList`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_PROJECT_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL",
                    payload: data.message || "Project list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseManagerLocalityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/localityList`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL",
                    payload: data.message || "Locality list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseManagerDetail = (id, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_DETAIL_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/view/${id}`,
                {},
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_DETAIL_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_DETAIL_FAIL",
                    payload: data.message || "Fetch failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_DETAIL_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const editFranchiseManager = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_EDIT_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/edit`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_EDIT_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_EDIT_FAIL",
                    payload: data.message || "Edit failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_EDIT_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const changeFranchiseManagerStatus = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_CHANGE_STATUS_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/change-status`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_CHANGE_STATUS_SUCCESS",
                    payload: { id: payload.id, status: payload.status },
                });
                toast.success(data.message || "Status updated successfully");
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_CHANGE_STATUS_FAIL",
                    payload: data.message || "Status update failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_CHANGE_STATUS_FAIL",
                payload: errorMessage,
            });
            toast.error(errorMessage);
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const changeFranchiseManagerDocumentStatus = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_DOCUMENT_STATUS_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/document-status`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_DOCUMENT_STATUS_SUCCESS",
                    payload: { id: payload.id, approval: payload.approval, reason: payload.reason ?? null },
                });
                toast.success(data.message || "Document status updated successfully");
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_DOCUMENT_STATUS_FAIL",
                    payload: data.message || "Document status update failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_DOCUMENT_STATUS_FAIL",
                payload: errorMessage,
            });
            toast.error(errorMessage);
            return Promise.reject(new Error(errorMessage));
        }
    };
};


export const getFranchiseManagerCityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/cityList`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_LIST_FAIL",
                    payload: data.message || "City list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_CITY_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const updateFranchiseManagerAccessControl = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_ACCESS_CONTROL_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/update-access-control`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_ACCESS_CONTROL_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_ACCESS_CONTROL_FAIL",
                    payload: data.message || "Access control update failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_ACCESS_CONTROL_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const deleteFranchiseManagerAccessControl = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/access-control/delete`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_FAIL",
                    payload: data.message || "Delete failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getCityHeadsList = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_CITY_HEADS_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/list-city-heads`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_HEADS_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_HEADS_FAIL",
                    payload: data.message || "Failed to fetch city heads",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_CITY_HEADS_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getLocalityHeadsList = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_HEADS_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/list-locality-heads`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_HEADS_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_HEADS_FAIL",
                    payload: data.message || "Failed to fetch locality heads",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_LOCALITY_HEADS_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const ListPartnersByHierarchy = (payload) => {
    return async (dispatch) => {
        dispatch({ type: "START_LOADING" });
        try {
            dispatch({ type: "LIST_PARTNERS_BY_HIERARCHY_REQUEST" });

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/list-partners-by-hierarchy`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "LIST_PARTNERS_BY_HIERARCHY_SUCCESS", payload: data });
                return Promise.resolve(data);
            } else {
                toast.error(data.message || "Failed to fetch partner list");
                dispatch({ type: "LIST_PARTNERS_BY_HIERARCHY_FAILED", payload: data.message });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Something went wrong!";
            toast.error(errorMessage);
            dispatch({
                type: "LIST_PARTNERS_BY_HIERARCHY_FAILED",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        } finally {
            dispatch({ type: "STOP_LOADING" });
        }
    };
};

export const listSiteVisits = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "SITE_VISIT_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/site-visit/list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "SITE_VISIT_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "SITE_VISIT_LIST_FAIL",
                    payload: data.message || "List failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "SITE_VISIT_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const viewSiteVisit = (id, payload = {}) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "SITE_VISIT_DETAIL_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/site-visit/view/${id}`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "SITE_VISIT_DETAIL_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "SITE_VISIT_DETAIL_FAIL",
                    payload: data.message || "Detail failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "SITE_VISIT_DETAIL_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const listHomeVisits = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "HOME_VISIT_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/home-visit/list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "HOME_VISIT_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "HOME_VISIT_LIST_FAIL",
                    payload: data.message || "List failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "HOME_VISIT_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const viewHomeVisit = (id, payload = {}) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "HOME_VISIT_DETAIL_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/home-visit/view/${id}`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "HOME_VISIT_DETAIL_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "HOME_VISIT_DETAIL_FAIL",
                    payload: data.message || "Detail failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "HOME_VISIT_DETAIL_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const addCityHead = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_CITY_HEAD_ADD_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/add-city-head`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_CITY_HEAD_ADD_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_CITY_HEAD_ADD_FAIL",
                    payload: data.message || "Add failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_CITY_HEAD_ADD_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseCityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/franchise-city-list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_CITY_LIST_FAIL",
                    payload: data.message || "City list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_CITY_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseLocalityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/franchise-locality-list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL",
                    payload: data.message || "Locality list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getFranchiseProjectListScoped = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/franchise-project-list`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_MANAGER_PROJECT_LIST_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL",
                    payload: data.message || "Project list failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const editCityHead = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_CITY_HEAD_EDIT_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/franchisy-manager/edit-city-head`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "FRANCHISE_CITY_HEAD_EDIT_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "FRANCHISE_CITY_HEAD_EDIT_FAIL",
                    payload: data.message || "Edit failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "FRANCHISE_CITY_HEAD_EDIT_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};


export const addLocalityHead = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_ADD_REQUEST" });
            const { data } = await axios.post(`${BASE_URL}/franchisy-manager/add-locality-head`, payload, config);
            if (data.statusCode === 200) {
                dispatch({ type: "FRANCHISE_LOCALITY_HEAD_ADD_SUCCESS", payload: data });
                return Promise.resolve(data);
            }
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_ADD_FAIL", payload: data.message || "Add failed" });
            return Promise.reject(new Error(data.message));
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_ADD_FAIL", payload: errorMessage });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const editLocalityHead = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_EDIT_REQUEST" });
            const { data } = await axios.post(`${BASE_URL}/franchisy-manager/edit-locality-head`, payload, config);
            if (data.statusCode === 200) {
                dispatch({ type: "FRANCHISE_LOCALITY_HEAD_EDIT_SUCCESS", payload: data });
                return Promise.resolve(data);
            }
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_EDIT_FAIL", payload: data.message || "Edit failed" });
            return Promise.reject(new Error(data.message));
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({ type: "FRANCHISE_LOCALITY_HEAD_EDIT_FAIL", payload: errorMessage });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getCityHeadCityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_REQUEST" });
            const { data } = await axios.post(`${BASE_URL}/franchisy-manager/city-head-city-list`, payload, config);
            if (data.statusCode === 200) {
                dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_SUCCESS", payload: data });
                return Promise.resolve(data);
            }
            dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_FAIL", payload: data.message || "City list failed" });
            return Promise.reject(new Error(data.message));
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({ type: "FRANCHISE_MANAGER_CITY_LIST_FAIL", payload: errorMessage });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getCityHeadLocalityList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_REQUEST" });
            const { data } = await axios.post(`${BASE_URL}/franchisy-manager/city-head-locality-list`, payload, config);
            if (data.statusCode === 200) {
                dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_SUCCESS", payload: data });
                return Promise.resolve(data);
            }
            dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL", payload: data.message || "Locality list failed" });
            return Promise.reject(new Error(data.message));
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({ type: "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL", payload: errorMessage });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const getCityHeadProjectList = (payload, showLoader = true) => {
    return async (dispatch) => {
        try {
            if (showLoader) dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_REQUEST" });
            const { data } = await axios.post(`${BASE_URL}/franchisy-manager/city-head-project-list`, payload, config);
            if (data.statusCode === 200) {
                dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_SUCCESS", payload: data });
                return Promise.resolve(data);
            }
            dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL", payload: data.message || "Project list failed" });
            return Promise.reject(new Error(data.message));
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({ type: "FRANCHISE_MANAGER_PROJECT_LIST_FAIL", payload: errorMessage });
            return Promise.reject(new Error(errorMessage));
        }
    };
};